import React from 'react';

import FiltersRefinementContentItem from '../FiltersRefinementContentItem';

import {IFiltersRefinementContentCheckboxProps} from './IFiltersRefinementContentCheckbox';

const FiltersRefinementContentCheckbox = ({refinement}: IFiltersRefinementContentCheckboxProps) => {
	if (!refinement) {
		return null;
	}

	return refinement.getValues().map((refinementValue) => {
		return <FiltersRefinementContentItem key={refinementValue.getKey()} refinementValue={refinementValue} />;
	});
};

export default FiltersRefinementContentCheckbox;